import { useGetGatsbyImages } from './get-image-from-gasby';

export const useGetImageNodeByPath = (relativePaths: string) => {
  const data = useGetGatsbyImages();

  return data.allFile.nodes.find((node) => node.relativePath === relativePaths);
};
